import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, useLocation } from "react-router-dom";
import App from "./App";
import AppErrorBoundary from "./components/AppErrorBoundary";
import reportWebVitals from "./reportWebVitals";
import { reportWebVital } from "./utils/telemetry";
import "./index.css";

function RoutedAppShell() {
  const location = useLocation();
  return (
    <AppErrorBoundary resetKey={`${location.pathname}${location.search}`}>
      <App />
    </AppErrorBoundary>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RoutedAppShell />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals(reportWebVital);
